// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knowledge-page {
  max-width: 1120px;
  margin: 0 auto;
  color: var(--lkfr-ink, #232737);
  --knowledge-red: #e72f44;
  --knowledge-muted: #657085;
  --knowledge-border: #e4e8ee;
}
.knowledge-page button, .knowledge-page input, .knowledge-page select {
  font: inherit;
}
.knowledge-page a {
  text-decoration: none;
}
.knowledge-page button:focus-visible, .knowledge-page a:focus-visible, .knowledge-page input:focus-visible, .knowledge-page select:focus-visible, .knowledge-page summary:focus-visible {
  outline: 3px solid #5365cc;
  outline-offset: 3px;
}
.knowledge-page .knowledge-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 22px;
}
.knowledge-page .knowledge-heading h1 {
  margin: 5px 0 0;
  font-size: clamp(28px, 3vw, 38px);
}
.knowledge-page .knowledge-eyebrow {
  color: var(--knowledge-muted);
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.12em;
}
.knowledge-page .knowledge-assistant {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 10px 15px;
  border: 1px solid var(--knowledge-border);
  border-radius: 13px;
  background: #fff;
  color: #31394d;
  font-size: 13px;
}
.knowledge-page .knowledge-assistant svg {
  width: 19px;
  height: 19px;
  color: #b62a42;
}
.knowledge-page .knowledge-hero {
  position: relative;
  padding: 28px;
  border-radius: 24px;
  border: 1px solid #f0dfe4;
  background: linear-gradient(125deg, #fff, #fff1f3);
  margin-bottom: 22px;
  overflow: hidden;
}
.knowledge-page .knowledge-hero > div {
  position: relative;
  padding-right: 80px;
}
.knowledge-page .knowledge-hero h2 {
  margin: 0 0 8px;
  font-size: 24px;
  letter-spacing: -0.025em;
}
.knowledge-page .knowledge-hero p {
  margin: 0 0 24px;
  max-width: 560px;
  color: var(--knowledge-muted);
  font-size: 14px;
  line-height: 1.6;
}
.knowledge-page .knowledge-hero-icon {
  position: absolute;
  right: 0;
  top: -2px;
  display: grid;
  place-items: center;
  width: 65px;
  height: 65px;
  background: #fff;
  border: 1px solid #f0dfe4;
  border-radius: 20px;
  color: #b62a42;
  transform: rotate(-7deg);
}
.knowledge-page .knowledge-hero-icon svg {
  width: 32px;
  height: 32px;
}
.knowledge-page .knowledge-search {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  background: #fff;
  padding: 7px 7px 7px 17px;
  border: 1px solid #e4dfe6;
  border-radius: 16px;
  box-shadow: 0 5px 18px rgba(53, 37, 53, 0.0196078431);
}
.knowledge-page .knowledge-search > svg {
  width: 21px;
  height: 21px;
  flex: 0 0 21px;
  color: var(--knowledge-muted);
}
.knowledge-page .knowledge-search input {
  min-width: 0;
  width: 100%;
  min-height: 42px;
  background: transparent;
  border: none;
  font-size: 16px;
  padding: 9px 0;
  color: var(--lkfr-ink);
}
.knowledge-page .knowledge-search button {
  min-height: 44px;
  padding: 10px 20px;
  background: #e72f44;
  color: #fff;
  border: none;
  border-radius: 11px;
  font-size: 14px;
  font-weight: 650;
}
.knowledge-page .knowledge-search input::placeholder {
  color: #8991a2;
}
.knowledge-page .knowledge-sections {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: thin;
  padding: 2px 3px 8px;
  margin: 0 -3px 24px;
  overscroll-behavior-inline: contain;
}
.knowledge-page .knowledge-sections button {
  display: flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
  flex: 0 0 auto;
  min-height: 44px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid var(--knowledge-border);
  background: #fff;
  color: #5c6679;
  font-size: 13px;
}
.knowledge-page .knowledge-sections button[aria-pressed=true] {
  color: #fff;
  background: #24394a;
  border-color: #24394a;
}
.knowledge-page .knowledge-sections svg {
  width: 17px;
  height: 17px;
}
.knowledge-page .knowledge-sections span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  min-height: 20px;
  padding: 2px 5px;
  border-radius: 6px;
  background: #f3f4f7;
  color: #657085;
  font-size: 10px;
}
.knowledge-page .knowledge-results-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 17px;
}
.knowledge-page .knowledge-results-heading h2 {
  font-size: 21px;
  margin: 0;
  overflow-wrap: anywhere;
}
.knowledge-page .knowledge-results-heading p {
  font-size: 12px;
  margin: 6px 0 0;
  color: var(--knowledge-muted);
}
.knowledge-page .knowledge-results-heading label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--knowledge-muted);
  flex: 0 0 auto;
}
.knowledge-page .knowledge-results-heading select {
  max-width: 220px;
  padding: 9px 12px;
  background: #fff;
  border: 1px solid var(--knowledge-border);
  border-radius: 11px;
  min-height: 44px;
  color: #31394d;
  font-size: 13px;
}
.knowledge-page .knowledge-reset {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: #ba253b;
  font-size: 12px;
  min-height: 44px;
  padding: 0;
  margin: -7px 0 7px;
}
.knowledge-page .knowledge-reset svg {
  width: 16px;
}
.knowledge-page .knowledge-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}
.knowledge-page .knowledge-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 240px;
  padding: 21px;
  border-radius: 19px;
  border: 1px solid var(--knowledge-border);
  background: #fff;
  color: inherit;
  transition: border-color 0.18s, box-shadow 0.18s, transform 0.18s;
}
.knowledge-page .knowledge-card:hover {
  border-color: #e7bfc6;
  box-shadow: 0 9px 24px rgba(37, 48, 71, 0.0274509804);
  transform: translateY(-2px);
}
.knowledge-page .knowledge-card h3 {
  margin: 17px 0 10px;
  font-size: 18px;
  line-height: 1.35;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
}
.knowledge-page .knowledge-card > p {
  color: var(--knowledge-muted);
  font-size: 13px;
  line-height: 1.65;
  margin: 0 0 20px;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.knowledge-page .knowledge-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.knowledge-page .knowledge-kind {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 550;
  padding: 5px 8px;
  border-radius: 7px;
  background: #f0f2f6;
  color: #59667d;
}
.knowledge-page .knowledge-kind.kind-guide {
  background: #fff0f2;
  color: #b63146;
}
.knowledge-page .knowledge-kind.kind-policy {
  background: #edf2fc;
  color: #4c68a0;
}
.knowledge-page .knowledge-kind.kind-faq {
  background: #edf7f0;
  color: #3d7654;
}
.knowledge-page .knowledge-pinned {
  color: #996d32;
  font-size: 10px;
}
.knowledge-page .knowledge-card-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  font-size: 11px;
  color: var(--knowledge-muted);
}
.knowledge-page .knowledge-card-arrow {
  display: grid;
  place-items: center;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  background: #f7f8fa;
  color: #657085;
  font-size: 18px;
}
.knowledge-page .knowledge-loading, .knowledge-page .knowledge-empty, .knowledge-page .knowledge-error {
  border-radius: 18px;
  padding: 30px;
  background: #fff;
  border: 1px solid var(--knowledge-border);
  margin-bottom: 16px;
  text-align: center;
  color: var(--knowledge-muted);
  font-size: 14px;
}
.knowledge-page .knowledge-loading {
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
}
.knowledge-page .knowledge-loading span {
  width: 15px;
  height: 15px;
  border: 2px solid #e2e5ec;
  border-top-color: #e72f44;
  border-radius: 50%;
  animation: knowledge-spin 0.8s linear infinite;
}
.knowledge-page .knowledge-empty {
  padding: 45px 25px;
}
.knowledge-page .knowledge-empty svg {
  width: 42px;
  height: 42px;
  color: #a0a9b9;
}
.knowledge-page .knowledge-empty h3 {
  color: #343e50;
  font-size: 19px;
  margin: 16px 0 8px;
}
.knowledge-page .knowledge-empty p {
  margin: 0;
  line-height: 1.6;
}
.knowledge-page .knowledge-error {
  text-align: left;
}
.knowledge-page .knowledge-error strong {
  color: #a5263b;
}
.knowledge-page .knowledge-error button {
  min-height: 44px;
  padding: 10px 15px;
  border: 1px solid #e7c9cf;
  background: #fff;
  color: #b3283f;
  border-radius: 11px;
  font-size: 13px;
}
.knowledge-page .knowledge-section-error {
  font-size: 12px;
  color: var(--knowledge-muted);
  margin-bottom: 16px;
}
.knowledge-page .knowledge-section-error button {
  background: none;
  border: none;
  min-height: 44px;
  color: #ba253b;
}
.knowledge-page .knowledge-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 28px 0;
  color: var(--knowledge-muted);
  font-size: 13px;
}
.knowledge-page .knowledge-pagination button {
  min-height: 44px;
  padding: 9px 16px;
  border-radius: 11px;
  border: 1px solid var(--knowledge-border);
  background: #fff;
  color: #364358;
}
.knowledge-page .knowledge-pagination button:disabled {
  opacity: 0.45;
}
.knowledge-page .knowledge-help {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 28px;
  padding: 20px;
  border-radius: 18px;
  background: #eef1f6;
}
.knowledge-page .knowledge-help > svg {
  color: #657085;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
}
.knowledge-page .knowledge-help strong {
  font-size: 14px;
}
.knowledge-page .knowledge-help p {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--knowledge-muted);
}
.knowledge-page .knowledge-help a {
  margin-left: auto;
  flex: 0 0 auto;
  color: #364358;
  font-size: 13px;
  min-height: 44px;
  display: flex;
  align-items: center;
}
.knowledge-page .knowledge-back {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: var(--knowledge-muted);
  font-size: 13px;
  margin-bottom: 12px;
}
.knowledge-page .knowledge-article {
  padding: 30px;
  border-radius: 24px;
  background: #fff;
  border: 1px solid var(--knowledge-border);
  min-width: 0;
}
.knowledge-page .knowledge-article-heading {
  padding-bottom: 26px;
  border-bottom: 1px solid var(--knowledge-border);
  margin-bottom: 28px;
}
.knowledge-page .knowledge-article-heading h1 {
  font-size: clamp(27px, 3vw, 36px);
  line-height: 1.23;
  margin: 15px 0;
  overflow-wrap: anywhere;
}
.knowledge-page .knowledge-article-tags {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.knowledge-page .knowledge-article-tags > span:not(.knowledge-kind) {
  font-size: 11px;
  color: var(--knowledge-muted);
}
.knowledge-page .knowledge-summary {
  font-size: 16px;
  color: var(--knowledge-muted);
  line-height: 1.65;
  max-width: 850px;
  margin: 0 0 18px;
}
.knowledge-page .knowledge-article-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  font-size: 11px;
  color: var(--knowledge-muted);
}
.knowledge-page .knowledge-article-meta a {
  color: #b82a40;
}
.knowledge-page .knowledge-reading-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 205px;
  gap: 28px;
  align-items: start;
}
.knowledge-page .knowledge-toc {
  grid-column: 2;
  grid-row: 1;
  position: sticky;
  top: 100px;
  padding: 14px;
  border: 1px solid var(--knowledge-border);
  border-radius: 14px;
  background: #fafbfc;
  max-height: calc(100dvh - 125px);
  overflow-y: auto;
}
.knowledge-page .knowledge-toc summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #354158;
  font-size: 12px;
  cursor: pointer;
  min-height: 32px;
  list-style: none;
}
.knowledge-page .knowledge-toc summary::-webkit-details-marker {
  display: none;
}
.knowledge-page .knowledge-toc summary span {
  color: #929bad;
  font-size: 10px;
}
.knowledge-page .knowledge-toc nav {
  display: flex;
  flex-direction: column;
  padding-top: 9px;
  gap: 2px;
}
.knowledge-page .knowledge-toc nav a {
  color: var(--knowledge-muted);
  font-size: 11px;
  line-height: 1.5;
  padding: 5px 0;
}
.knowledge-page .knowledge-toc nav a:hover {
  color: #b82a40;
}
.knowledge-page .knowledge-prose {
  min-width: 0;
  grid-column: 1;
  grid-row: 1;
  font-size: 15px;
  line-height: 1.8;
  color: #364154;
  overflow-wrap: anywhere;
}
.knowledge-page .knowledge-prose > :first-child {
  margin-top: 0;
}
.knowledge-page .knowledge-prose p {
  line-height: inherit;
  margin: 0 0 18px;
}
.knowledge-page .knowledge-prose h2 {
  font-size: 23px;
  line-height: 1.4;
  letter-spacing: -0.025em;
  color: #243449;
  margin: 38px 0 16px;
  scroll-margin-top: 110px;
}
.knowledge-page .knowledge-prose h3 {
  font-size: 19px;
  line-height: 1.45;
  color: #243449;
  margin: 25px 0 13px;
}
.knowledge-page .knowledge-prose strong {
  color: #27364a;
}
.knowledge-page .knowledge-prose ul, .knowledge-page .knowledge-prose ol {
  padding-left: 22px;
  margin: 14px 0 23px;
}
.knowledge-page .knowledge-prose li {
  margin: 0 0 10px;
  padding-left: 4px;
}
.knowledge-page .knowledge-prose a, .knowledge-page .knowledge-prose .knowledge-file-link {
  color: #bd2940;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.knowledge-page .knowledge-prose figure {
  margin: 24px 0;
  max-width: 100%;
}
.knowledge-page .knowledge-prose figcaption {
  margin-top: 9px;
  text-align: left;
  color: #818a9a;
  font-size: 12px;
  line-height: 1.6;
}
.knowledge-page .knowledge-prose blockquote {
  margin: 20px 0;
  padding: 15px 18px;
  background: #f7f8fb;
  border-left: 3px solid #dce3ec;
  border-radius: 0 10px 10px 0;
}
.knowledge-page .knowledge-prose pre {
  max-width: 100%;
  overflow-x: auto;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 12px;
  font-size: 13px;
}
.knowledge-page .knowledge-prose iframe {
  width: 100%;
  border: 0;
  aspect-ratio: 16/9;
  border-radius: 12px;
}
.knowledge-page .knowledge-prose table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.knowledge-page .knowledge-prose td, .knowledge-page .knowledge-prose th {
  border: 1px solid var(--knowledge-border);
  padding: 10px;
  text-align: left;
  min-width: 95px;
}
.knowledge-page .knowledge-prose th {
  background: #f7f8fa;
}
.knowledge-page .knowledge-prose .knowledge-table {
  overflow-x: auto;
  max-width: 100%;
  margin: 24px 0;
}
.knowledge-page .knowledge-image-button {
  display: block;
  width: 100%;
  padding: 0;
  border: 1px solid var(--knowledge-border);
  background: #f7f8fb;
  border-radius: 13px;
  overflow: hidden;
  color: #7b8799;
  cursor: zoom-in;
}
.knowledge-page .knowledge-image-button img {
  display: block;
  max-width: 100%;
  height: auto;
  width: auto;
  max-height: none;
  margin: auto;
}
.knowledge-page .knowledge-image-button > span {
  display: block;
  text-align: center;
  font-size: 10px;
  padding: 7px 10px;
}
.knowledge-page .knowledge-image-state {
  display: block;
  padding: 28px 16px;
  font-size: 12px;
  background: #f7f8fb;
  border-radius: 13px;
  text-align: center;
}
.knowledge-page .knowledge-image-state button {
  min-height: 44px;
  background: none;
  border: none;
  color: #b72a40;
}
.knowledge-page .knowledge-file-link {
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  min-height: 44px;
}
.knowledge-page .knowledge-article-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  border-top: 1px solid var(--knowledge-border);
  padding-top: 24px;
  margin-top: 30px;
}
.knowledge-page .knowledge-article-footer strong {
  font-size: 14px;
}
.knowledge-page .knowledge-article-footer p {
  font-size: 12px;
  margin: 5px 0 0;
  color: var(--knowledge-muted);
}
.knowledge-page .knowledge-article-footer a {
  color: #b82a40;
  font-size: 13px;
  min-height: 44px;
  display: flex;
  align-items: center;
}
.knowledge-page .knowledge-lightbox img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: auto;
}
@media (max-width: 1150px) {
  .knowledge-page .knowledge-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 999px) {
  .knowledge-page .knowledge-reading-layout {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .knowledge-page .knowledge-toc {
    position: static;
    max-height: none;
    width: 100%;
  }
  .knowledge-page .knowledge-toc summary {
    min-height: 40px;
  }
  .knowledge-page .knowledge-toc nav a {
    font-size: 13px;
    padding-block: 8px;
  }
  .knowledge-page .knowledge-prose {
    width: 100%;
  }
}
@media (max-width: 650px) {
  .knowledge-page .knowledge-heading {
    gap: 9px;
    margin-bottom: 20px;
    align-items: flex-end;
  }
  .knowledge-page .knowledge-heading h1 {
    font-size: 28px;
  }
  .knowledge-page .knowledge-assistant {
    font-size: 11px;
    padding: 8px 10px;
    gap: 5px;
    max-width: 146px;
  }
  .knowledge-page .knowledge-eyebrow {
    font-size: 9px;
    letter-spacing: 0.1em;
  }
  .knowledge-page .knowledge-hero {
    padding: 19px;
    border-radius: 20px;
    margin-bottom: 17px;
  }
  .knowledge-page .knowledge-hero > div {
    padding-right: 43px;
  }
  .knowledge-page .knowledge-hero h2 {
    font-size: 21px;
    max-width: 235px;
  }
  .knowledge-page .knowledge-hero p {
    font-size: 13px;
    margin-bottom: 19px;
  }
  .knowledge-page .knowledge-hero-icon {
    width: 40px;
    height: 40px;
    border-radius: 13px;
    right: -2px;
    top: 0;
  }
  .knowledge-page .knowledge-hero-icon svg {
    width: 24px;
    height: 24px;
  }
  .knowledge-page .knowledge-search {
    gap: 6px;
    padding: 5px 5px 5px 11px;
    border-radius: 13px;
  }
  .knowledge-page .knowledge-search input {
    font-size: 16px;
  }
  .knowledge-page .knowledge-search button {
    padding-inline: 12px;
    font-size: 12px;
  }
  .knowledge-page .knowledge-search > svg {
    width: 18px;
    flex-basis: 18px;
  }
  .knowledge-page .knowledge-sections {
    margin-bottom: 18px;
  }
  .knowledge-page .knowledge-results-heading {
    align-items: flex-start;
    gap: 9px;
  }
  .knowledge-page .knowledge-results-heading h2 {
    font-size: 18px;
  }
  .knowledge-page .knowledge-results-heading label {
    font-size: 0;
  }
  .knowledge-page .knowledge-results-heading select {
    font-size: 12px;
    max-width: 139px;
  }
  .knowledge-page .knowledge-cards {
    grid-template-columns: minmax(0, 1fr);
    gap: 11px;
  }
  .knowledge-page .knowledge-card {
    min-height: 0;
    padding: 18px;
  }
  .knowledge-page .knowledge-card h3 {
    font-size: 19px;
    margin-top: 15px;
  }
  .knowledge-page .knowledge-card > p {
    font-size: 13px;
    margin-bottom: 17px;
  }
  .knowledge-page .knowledge-help {
    flex-wrap: wrap;
    padding: 18px;
    gap: 11px;
  }
  .knowledge-page .knowledge-help > div {
    flex: 1 1;
    min-width: 0;
  }
  .knowledge-page .knowledge-help a {
    margin-left: 35px;
  }
  .knowledge-page .knowledge-article {
    padding: 20px 17px;
    border-radius: 20px;
  }
  .knowledge-page .knowledge-article-heading {
    padding-bottom: 22px;
    margin-bottom: 22px;
  }
  .knowledge-page .knowledge-article-heading h1 {
    font-size: 28px;
  }
  .knowledge-page .knowledge-summary {
    font-size: 14px;
  }
  .knowledge-page .knowledge-article-meta {
    gap: 8px 12px;
    font-size: 10px;
  }
  .knowledge-page .knowledge-prose {
    font-size: 16px;
    line-height: 1.75;
  }
  .knowledge-page .knowledge-prose h2 {
    font-size: 23px;
    margin-top: 32px;
  }
  .knowledge-page .knowledge-prose ul, .knowledge-page .knowledge-prose ol {
    padding-left: 20px;
  }
  .knowledge-page .knowledge-prose figcaption {
    font-size: 11px;
  }
  .knowledge-page .knowledge-article-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 7px;
  }
  .knowledge-page .knowledge-lightbox {
    padding: 16px 10px;
    width: calc(100vw - 12px);
    max-width: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .knowledge-page .knowledge-card {
    transition: none;
  }
  .knowledge-page .knowledge-loading span {
    animation: none;
  }
}

@keyframes knowledge-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/KnowledgePage/KnowledgePage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EAAmB,cAAA;EAAgB,+BAAA;EACnC,wBAAA;EAA0B,0BAAA;EAA4B,2BAAA;AAKxD;AAJE;EAAwB,aAAA;AAO1B;AANE;EAAI,qBAAA;AASN;AARsC;EAAkB,0BAAA;EAA4B,mBAAA;AAYpF;AAXE;EAAqB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,mBAAA;AAkBtG;AAlB2H;EAAK,eAAA;EAAiB,iCAAA;AAsBjJ;AArBE;EAAqB,6BAAA;EAA+B,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;AA2BzF;AA1BE;EAAuB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,kBAAA;EAAoB,yCAAA;EAA2C,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;AAsCtN;AAtCuO;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;AA2CxQ;AA1CE;EAAkB,kBAAA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,yBAAA;EAA2B,kDAAA;EAAoD,mBAAA;EAAqB,gBAAA;AAmDhL;AAlDI;EAAQ,kBAAA;EAAoB,mBAAA;AAsDhC;AAtDuD;EAAK,eAAA;EAAiB,eAAA;EAAiB,wBAAA;AA2D9F;AA3DyH;EAAI,gBAAA;EAAkB,gBAAA;EAAkB,6BAAA;EAA+B,eAAA;EAAiB,gBAAA;AAkEjN;AAhEE;EAAuB,kBAAA;EAAoB,QAAA;EAAU,SAAA;EAAW,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,cAAA;EAAgB,wBAAA;AA8EnN;AA9E6O;EAAM,WAAA;EAAa,YAAA;AAkFhQ;AAjFE;EAAoB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,gBAAA;EAAkB,yBAAA;EAA2B,yBAAA;EAA2B,mBAAA;EAAqB,qDAAA;AA4FtL;AA3FI;EAAQ,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,6BAAA;AAiGvD;AAjGwF;EAAQ,YAAA;EAAc,WAAA;EAAa,gBAAA;EAAkB,uBAAA;EAAyB,YAAA;EAAc,eAAA;EAAiB,cAAA;EAAgB,sBAAA;AA2GrN;AA3G+O;EAAS,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;AAqHpX;AArHwY;EAAqB,cAAA;AAwH7Z;AAtHE;EAAsB,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,qBAAA;EAAuB,oBAAA;EAAsB,mBAAA;EAAqB,mCAAA;AAgI1J;AA/HI;EAAS,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,mBAAA;EAAqB,cAAA;EAAgB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,yCAAA;EAA2C,gBAAA;EAAkB,cAAA;EAAgB,eAAA;AA6IxO;AA7I2P;EAA4B,WAAA;EAAa,mBAAA;EAAqB,qBAAA;AAkJzT;AAlJkV;EAAM,WAAA;EAAa,YAAA;AAsJrW;AAtJqX;EAAO,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,cAAA;EAAgB,eAAA;AAkK9iB;AAhKE;EAA6B,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,mBAAA;AAuK9G;AAvKmI;EAAK,eAAA;EAAiB,SAAA;EAAW,uBAAA;AA4KpK;AA5K+L;EAAI,eAAA;EAAiB,eAAA;EAAiB,6BAAA;AAiLrO;AAjLsQ;EAAQ,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,6BAAA;EAA+B,cAAA;AAyL5W;AAzL8X;EAAS,gBAAA;EAAkB,iBAAA;EAAmB,gBAAA;EAAkB,yCAAA;EAA2C,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;AAmMhiB;AAlME;EAAmB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,uBAAA;EAAyB,YAAA;EAAc,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,UAAA;EAAY,kBAAA;AA8MhL;AA9MoM;EAAM,WAAA;AAiN1M;AAhNE;EAAmB,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAqNtF;AApNE;EAAkB,aAAA;EAAe,sBAAA;EAAwB,YAAA;EAAc,iBAAA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,yCAAA;EAA2C,gBAAA;EAAkB,cAAA;EAAgB,iEAAA;AAgO7M;AA/NI;EAAU,qBAAA;EAAuB,qDAAA;EAAkC,2BAAA;AAoOvE;AApOsG;EAAK,mBAAA;EAAqB,eAAA;EAAiB,iBAAA;EAAmB,uBAAA;EAAwB,uBAAA;AA2O5L;AA3OuN;EAAM,6BAAA;EAA+B,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;EAAkB,uBAAA;EAAyB,oBAAA;EAAsB,qBAAA;EAAuB,4BAAA;EAA8B,gBAAA;AAsPtZ;AApPE;EAAsB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;AA0P5F;AAzPE;EAAkB,oBAAA;EAAsB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,cAAA;AAmQ7J;AAnQ6K;EAAe,mBAAA;EAAqB,cAAA;AAuQjN;AAvQmO;EAAgB,mBAAA;EAAqB,cAAA;AA2QxQ;AA3Q0R;EAAa,mBAAA;EAAqB,cAAA;AA+Q5T;AA9QE;EAAoB,cAAA;EAAgB,eAAA;AAkRtC;AAjRE;EAAyB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,gBAAA;EAAkB,eAAA;EAAiB,6BAAA;AA0R7I;AAzRE;EAAwB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,cAAA;EAAgB,eAAA;AAmS1J;AAlSE;EAAyD,mBAAA;EAAqB,aAAA;EAAe,gBAAA;EAAkB,yCAAA;EAA2C,mBAAA;EAAqB,kBAAA;EAAoB,6BAAA;EAA+B,eAAA;AA4SpO;AA3SE;EAAqB,aAAA;EAAe,uBAAA;EAAyB,SAAA;EAAW,mBAAA;AAiT1E;AAjT+F;EAAO,WAAA;EAAa,YAAA;EAAc,yBAAA;EAA2B,yBAAA;EAA2B,kBAAA;EAAoB,8CAAA;AAyT3M;AAxTE;EAAmB,kBAAA;AA2TrB;AA3TyC;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;AAgU1E;AAhU4F;EAAK,cAAA;EAAgB,eAAA;EAAiB,kBAAA;AAqUlI;AArUwJ;EAAI,SAAA;EAAW,gBAAA;AAyUvK;AAxUE;EAAmB,gBAAA;AA2UrB;AA3UuC;EAAS,cAAA;AA8UhD;AA9UkE;EAAS,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAA2B,gBAAA;EAAkB,cAAA;EAAgB,mBAAA;EAAqB,eAAA;AAuVnM;AAtVE;EAA2B,eAAA;EAAiB,6BAAA;EAA+B,mBAAA;AA2V7E;AA3VkG;EAAS,gBAAA;EAAkB,YAAA;EAAc,gBAAA;EAAkB,cAAA;AAiW7J;AAhWE;EAAwB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,SAAA;EAAW,cAAA;EAAgB,6BAAA;EAA+B,eAAA;AAyWjJ;AAzWkK;EAAS,gBAAA;EAAkB,iBAAA;EAAmB,mBAAA;EAAqB,yCAAA;EAA2C,gBAAA;EAAkB,cAAA;AAiXlS;AAjXoT;EAAkB,aAAA;AAoXtU;AAnXE;EAAkB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;AA4XzH;AA5X8I;EAAQ,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,cAAA;AAkYjM;AAlYmN;EAAS,eAAA;AAqY5N;AArY+O;EAAI,eAAA;EAAiB,eAAA;EAAiB,6BAAA;AA0YrR;AA1YsT;EAAI,iBAAA;EAAmB,cAAA;EAAgB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,aAAA;EAAe,mBAAA;AAmZ/Z;AAlZE;EAAkB,oBAAA;EAAsB,mBAAA;EAAqB,gBAAA;EAAkB,6BAAA;EAA+B,eAAA;EAAiB,mBAAA;AA0ZjI;AAzZE;EAAqB,aAAA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,yCAAA;EAA2C,YAAA;AAgaxH;AA/ZE;EAA6B,oBAAA;EAAsB,gDAAA;EAAkD,mBAAA;AAoavG;AApa4H;EAAK,iCAAA;EAAmC,iBAAA;EAAmB,cAAA;EAAgB,uBAAA;AA0avM;AAzaE;EAA0B,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;AA+a3E;AA/a4F;EAA8B,eAAA;EAAiB,6BAAA;AAmb3I;AAlbE;EAAqB,eAAA;EAAiB,6BAAA;EAA+B,iBAAA;EAAmB,gBAAA;EAAkB,gBAAA;AAyb5G;AAxbE;EAA0B,aAAA;EAAe,eAAA;EAAiB,aAAA;EAAe,eAAA;EAAiB,6BAAA;AA+b5F;AA/b2H;EAAI,cAAA;AAkc/H;AAjcE;EAA4B,aAAA;EAAe,2CAAA;EAA6C,SAAA;EAAW,kBAAA;AAucrG;AAtcE;EAAiB,cAAA;EAAgB,WAAA;EAAa,gBAAA;EAAkB,UAAA;EAAY,aAAA;EAAe,yCAAA;EAA2C,mBAAA;EAAqB,mBAAA;EAAqB,gCAAA;EAAkC,gBAAA;AAkdpN;AAjdI;EAAU,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,cAAA;EAAgB,eAAA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AA4djK;AA5dmL;EAA4B,aAAA;AA+d/M;AA/dgO;EAAO,cAAA;EAAgB,eAAA;AAmevP;AAne4Q;EAAM,aAAA;EAAe,sBAAA;EAAwB,gBAAA;EAAkB,QAAA;AAye3U;AAzeuV;EAAQ,6BAAA;EAA+B,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AA+eja;AA/eib;EAAU,cAAA;AAkf3b;AAhfE;EAAmB,YAAA;EAAc,cAAA;EAAgB,WAAA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,uBAAA;AAyfnH;AAxfI;EAAiB,aAAA;AA2frB;AA3fsC;EAAI,oBAAA;EAAsB,gBAAA;AA+fhE;AA/foF;EAAK,eAAA;EAAiB,gBAAA;EAAkB,wBAAA;EAAyB,cAAA;EAAgB,mBAAA;EAAqB,wBAAA;AAugB1L;AAvgBsN;EAAK,eAAA;EAAiB,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;AA6gB/Q;AA7gBsS;EAAS,cAAA;AAghB/S;AAhhBiU;EAAS,kBAAA;EAAoB,mBAAA;AAohB9V;AAphBqX;EAAK,gBAAA;EAAkB,iBAAA;AAwhB5Y;AAxhBia;EAA0B,cAAA;EAAgB,0BAAA;EAA4B,0BAAA;AA6hBve;AA7hBqgB;EAAS,cAAA;EAAgB,eAAA;AAiiB9hB;AAjiBijB;EAAa,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAwiBloB;AAxiBspB;EAAa,cAAA;EAAgB,kBAAA;EAAoB,mBAAA;EAAqB,8BAAA;EAAgC,4BAAA;AA+iB5vB;AA/iB4xB;EAAM,eAAA;EAAiB,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,eAAA;AAujB93B;AAvjBi5B;EAAS,WAAA;EAAa,SAAA;EAAW,kBAAA;EAAsB,mBAAA;AA6jBx8B;AA7jB+9B;EAAQ,WAAA;EAAa,yBAAA;EAA2B,eAAA;AAkkB/gC;AAlkBkiC;EAAS,yCAAA;EAA2C,aAAA;EAAe,gBAAA;EAAkB,eAAA;AAwkBvnC;AAxkB0oC;EAAK,mBAAA;AA2kB/oC;AA3kBsqC;EAAmB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAglB5tC;AA9kBE;EAA0B,cAAA;EAAgB,WAAA;EAAa,UAAA;EAAY,yCAAA;EAA2C,mBAAA;EAAqB,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;AAylB5L;AAxlBI;EAAM,cAAA;EAAgB,eAAA;EAAiB,YAAA;EAAc,WAAA;EAAa,gBAAA;EAAkB,YAAA;AAgmBxF;AAhmBwG;EAAS,cAAA;EAAgB,kBAAA;EAAoB,eAAA;EAAiB,iBAAA;AAsmBtK;AApmBE;EAAyB,cAAA;EAAgB,kBAAA;EAAoB,eAAA;EAAiB,mBAAA;EAAqB,mBAAA;EAAqB,kBAAA;AA4mB1H;AA5mB8I;EAAS,gBAAA;EAAkB,gBAAA;EAAkB,YAAA;EAAc,cAAA;AAknBzM;AAjnBE;EAAuB,gBAAA;EAAkB,YAAA;EAAc,UAAA;EAAY,gBAAA;EAAkB,gBAAA;AAwnBvF;AAvnBE;EAA4B,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,6CAAA;EAA+C,iBAAA;EAAmB,gBAAA;AAgoB/K;AAhoBiM;EAAS,eAAA;AAmoB1M;AAnoB6N;EAAI,eAAA;EAAiB,eAAA;EAAiB,6BAAA;AAwoBnQ;AAxoBoS;EAAI,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,aAAA;EAAe,mBAAA;AA+oB1W;AA9oBE;EAA0B,cAAA;EAAgB,eAAA;EAAiB,YAAA;EAAc,YAAA;AAopB3E;AAnpBE;EAA6B;IAAmB,gDAAA;EAupBhD;AACF;AAvpBE;EACE;IAA4B,aAAA;IAAe,sBAAA;IAAwB,SAAA;EA4pBrE;EA5pBkF;IAAiB,gBAAA;IAAkB,gBAAA;IAAkB,WAAA;EAiqBvI;EAjqBsJ;IAAyB,gBAAA;EAoqB/K;EApqBmM;IAAuB,eAAA;IAAiB,kBAAA;EAwqB3O;EAxqBiQ;IAAmB,WAAA;EA2qBpR;AACF;AA1qBE;EACE;IAAqB,QAAA;IAAU,mBAAA;IAAqB,qBAAA;EA+qBtD;EA/qB+E;IAAwB,eAAA;EAkrBvG;EAlrB0H;IAAuB,eAAA;IAAiB,iBAAA;IAAmB,QAAA;IAAU,gBAAA;EAwrB/L;EAxrBmN;IAAqB,cAAA;IAAgB,qBAAA;EA4rBxP;EA3rBE;IAAkB,aAAA;IAAe,mBAAA;IAAqB,mBAAA;EAgsBxD;EAhsB6E;IAAQ,mBAAA;EAmsBrF;EAnsB4G;IAAK,eAAA;IAAiB,gBAAA;EAusBlI;EAvsBsJ;IAAI,eAAA;IAAiB,mBAAA;EA2sB3K;EA3sBoM;IAAuB,WAAA;IAAa,YAAA;IAAc,mBAAA;IAAqB,WAAA;IAAa,MAAA;EAktBxR;EAltBgS;IAAM,WAAA;IAAa,YAAA;EAstBnT;EArtBE;IAAoB,QAAA;IAAU,yBAAA;IAA2B,mBAAA;EA0tB3D;EA1tBgF;IAAQ,eAAA;EA6tBxF;EA7tB2G;IAAS,oBAAA;IAAsB,eAAA;EAiuB1I;EAjuB6J;IAAQ,WAAA;IAAa,gBAAA;EAquBlL;EApuBE;IAAsB,mBAAA;EAuuBxB;EAtuBE;IAA6B,uBAAA;IAAyB,QAAA;EA0uBxD;EA1uBkE;IAAK,eAAA;EA6uBvE;EA7uB0F;IAAQ,YAAA;EAgvBlG;EAhvBkH;IAAS,eAAA;IAAiB,gBAAA;EAovB5I;EAnvBE;IAAmB,qCAAA;IAAuC,SAAA;EAuvB5D;EAvvByE;IAAkB,aAAA;IAAe,aAAA;EA2vB1G;EA3vByH;IAAK,eAAA;IAAiB,gBAAA;EA+vB/I;EA/vBmK;IAAM,eAAA;IAAiB,mBAAA;EAmwB1L;EAlwBE;IAAkB,eAAA;IAAiB,aAAA;IAAe,SAAA;EAuwBpD;EAvwB+D;IAAQ,SAAA;IAAS,YAAA;EA2wBhF;EA3wBgG;IAAI,iBAAA;EA8wBpG;EA7wBE;IAAqB,kBAAA;IAAoB,mBAAA;EAixB3C;EAjxBkE;IAA6B,oBAAA;IAAsB,mBAAA;EAqxBrH;EArxB0I;IAAK,eAAA;EAwxB/I;EAxxBoK;IAAqB,eAAA;EA2xBzL;EA3xB4M;IAA0B,aAAA;IAAe,eAAA;EA+xBrP;EA9xBE;IAAmB,eAAA;IAAiB,iBAAA;EAkyBtC;EAlyByD;IAAK,eAAA;IAAiB,gBAAA;EAsyB/E;EAtyBmG;IAAS,kBAAA;EAyyB5G;EAzyBkI;IAAa,eAAA;EA4yB/I;EA3yBE;IAA4B,sBAAA;IAAwB,uBAAA;IAAyB,QAAA;EAgzB/E;EA/yBE;IAAsB,kBAAA;IAAoB,yBAAA;IAA2B,eAAA;EAozBvE;AACF;AAnzBE;EAA0C;IAAkB,gBAAA;EAuzB5D;EAvzBgF;IAA0B,eAAA;EA0zB1G;AACF;;AAzzBA;EAA4B;IAAK,yBAAA;EA8zB/B;AACF","sourcesContent":[".knowledge-page {\n  max-width: 1120px; margin: 0 auto; color: var(--lkfr-ink, #232737);\n  --knowledge-red: #e72f44; --knowledge-muted: #657085; --knowledge-border: #e4e8ee;\n  button, input, select { font: inherit; }\n  a { text-decoration: none; }\n  button, a, input, select, summary { &:focus-visible { outline: 3px solid #5365cc; outline-offset: 3px; } }\n  .knowledge-heading { display: flex; align-items: center; justify-content: space-between; gap: 20px; margin-bottom: 22px; h1 { margin: 5px 0 0; font-size: clamp(28px, 3vw, 38px); } }\n  .knowledge-eyebrow { color: var(--knowledge-muted); font-size: 10px; font-weight: 650; letter-spacing: .12em; }\n  .knowledge-assistant { display: inline-flex; align-items: center; gap: 8px; min-height: 44px; padding: 10px 15px; border: 1px solid var(--knowledge-border); border-radius: 13px; background: #fff; color: #31394d; font-size: 13px; svg { width: 19px; height: 19px; color: #b62a42; } }\n  .knowledge-hero { position: relative; padding: 28px; border-radius: 24px; border: 1px solid #f0dfe4; background: linear-gradient(125deg, #fff, #fff1f3); margin-bottom: 22px; overflow: hidden;\n    > div { position: relative; padding-right: 80px; } h2 { margin: 0 0 8px; font-size: 24px; letter-spacing: -.025em; } p { margin: 0 0 24px; max-width: 560px; color: var(--knowledge-muted); font-size: 14px; line-height: 1.6; }\n  }\n  .knowledge-hero-icon { position: absolute; right: 0; top: -2px; display: grid; place-items: center; width: 65px; height: 65px; background: #fff; border: 1px solid #f0dfe4; border-radius: 20px; color: #b62a42; transform: rotate(-7deg); svg { width: 32px; height: 32px; } }\n  .knowledge-search { display: flex; align-items: center; gap: 10px; position: relative; background: #fff; padding: 7px 7px 7px 17px; border: 1px solid #e4dfe6; border-radius: 16px; box-shadow: 0 5px 18px #35253505;\n    > svg { width: 21px; height: 21px; flex: 0 0 21px; color: var(--knowledge-muted); } input { min-width: 0; width: 100%; min-height: 42px; background: transparent; border: none; font-size: 16px; padding: 9px 0; color: var(--lkfr-ink); } button { min-height: 44px; padding: 10px 20px; background: #e72f44; color: #fff; border: none; border-radius: 11px; font-size: 14px; font-weight: 650; } input::placeholder { color: #8991a2; }\n  }\n  .knowledge-sections { display: flex; align-items: center; gap: 8px; overflow-x: auto; scrollbar-width: thin; padding: 2px 3px 8px; margin: 0 -3px 24px; overscroll-behavior-inline: contain;\n    button { display: flex; align-items: center; gap: 7px; white-space: nowrap; flex: 0 0 auto; min-height: 44px; padding: 10px 14px; border-radius: 12px; border: 1px solid var(--knowledge-border); background: #fff; color: #5c6679; font-size: 13px; } button[aria-pressed=true] { color: #fff; background: #24394a; border-color: #24394a; } svg { width: 17px; height: 17px; } span { display: inline-flex; align-items: center; justify-content: center; min-width: 22px; min-height: 20px; padding: 2px 5px; border-radius: 6px; background: #f3f4f7; color: #657085; font-size: 10px; }\n  }\n  .knowledge-results-heading { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 17px; h2 { font-size: 21px; margin: 0; overflow-wrap: anywhere; } p { font-size: 12px; margin: 6px 0 0; color: var(--knowledge-muted); } label { display: flex; align-items: center; gap: 8px; font-size: 12px; color: var(--knowledge-muted); flex: 0 0 auto; } select { max-width: 220px; padding: 9px 12px; background: #fff; border: 1px solid var(--knowledge-border); border-radius: 11px; min-height: 44px; color: #31394d; font-size: 13px; } }\n  .knowledge-reset { display: inline-flex; align-items: center; gap: 6px; background: transparent; border: none; color: #ba253b; font-size: 12px; min-height: 44px; padding: 0; margin: -7px 0 7px; svg { width: 16px; } }\n  .knowledge-cards { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px; }\n  .knowledge-card { display: flex; flex-direction: column; min-width: 0; min-height: 240px; padding: 21px; border-radius: 19px; border: 1px solid var(--knowledge-border); background: #fff; color: inherit; transition: border-color .18s, box-shadow .18s, transform .18s;\n    &:hover { border-color: #e7bfc6; box-shadow: 0 9px 24px #25304707; transform: translateY(-2px); } h3 { margin: 17px 0 10px; font-size: 18px; line-height: 1.35; letter-spacing: -.02em; overflow-wrap: anywhere; } > p { color: var(--knowledge-muted); font-size: 13px; line-height: 1.65; margin: 0 0 20px; overflow-wrap: anywhere; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }\n  }\n  .knowledge-card-top { display: flex; align-items: center; justify-content: space-between; gap: 6px; }\n  .knowledge-kind { display: inline-flex; align-items: center; font-size: 10px; font-weight: 550; padding: 5px 8px; border-radius: 7px; background: #f0f2f6; color: #59667d; &.kind-guide { background: #fff0f2; color: #b63146; } &.kind-policy { background: #edf2fc; color: #4c68a0; } &.kind-faq { background: #edf7f0; color: #3d7654; } }\n  .knowledge-pinned { color: #996d32; font-size: 10px; }\n  .knowledge-card-bottom { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-top: auto; font-size: 11px; color: var(--knowledge-muted); }\n  .knowledge-card-arrow { display: grid; place-items: center; min-width: 32px; min-height: 32px; border-radius: 50%; background: #f7f8fa; color: #657085; font-size: 18px; }\n  .knowledge-loading, .knowledge-empty, .knowledge-error { border-radius: 18px; padding: 30px; background: #fff; border: 1px solid var(--knowledge-border); margin-bottom: 16px; text-align: center; color: var(--knowledge-muted); font-size: 14px; }\n  .knowledge-loading { display: flex; justify-content: center; gap: 10px; align-items: center; span { width: 15px; height: 15px; border: 2px solid #e2e5ec; border-top-color: #e72f44; border-radius: 50%; animation: knowledge-spin .8s linear infinite; } }\n  .knowledge-empty { padding: 45px 25px; svg { width: 42px; height: 42px; color: #a0a9b9; } h3 { color: #343e50; font-size: 19px; margin: 16px 0 8px; } p { margin: 0; line-height: 1.6; } }\n  .knowledge-error { text-align: left; strong { color: #a5263b; } button { min-height: 44px; padding: 10px 15px; border: 1px solid #e7c9cf; background: #fff; color: #b3283f; border-radius: 11px; font-size: 13px; } }\n  .knowledge-section-error { font-size: 12px; color: var(--knowledge-muted); margin-bottom: 16px; button { background: none; border: none; min-height: 44px; color: #ba253b; } }\n  .knowledge-pagination { display: flex; align-items: center; justify-content: center; gap: 20px; margin: 28px 0; color: var(--knowledge-muted); font-size: 13px; button { min-height: 44px; padding: 9px 16px; border-radius: 11px; border: 1px solid var(--knowledge-border); background: #fff; color: #364358; } button:disabled { opacity: .45; } }\n  .knowledge-help { display: flex; align-items: center; gap: 14px; margin-top: 28px; padding: 20px; border-radius: 18px; background: #eef1f6; > svg { color: #657085; width: 24px; height: 24px; flex: 0 0 24px; } strong { font-size: 14px; } p { margin: 4px 0 0; font-size: 12px; color: var(--knowledge-muted); } a { margin-left: auto; flex: 0 0 auto; color: #364358; font-size: 13px; min-height: 44px; display: flex; align-items: center; } }\n  .knowledge-back { display: inline-flex; align-items: center; min-height: 44px; color: var(--knowledge-muted); font-size: 13px; margin-bottom: 12px; }\n  .knowledge-article { padding: 30px; border-radius: 24px; background: #fff; border: 1px solid var(--knowledge-border); min-width: 0; }\n  .knowledge-article-heading { padding-bottom: 26px; border-bottom: 1px solid var(--knowledge-border); margin-bottom: 28px; h1 { font-size: clamp(27px, 3vw, 36px); line-height: 1.23; margin: 15px 0; overflow-wrap: anywhere; } }\n  .knowledge-article-tags { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; > span:not(.knowledge-kind) { font-size: 11px; color: var(--knowledge-muted); } }\n  .knowledge-summary { font-size: 16px; color: var(--knowledge-muted); line-height: 1.65; max-width: 850px; margin: 0 0 18px; }\n  .knowledge-article-meta { display: flex; flex-wrap: wrap; gap: 8px 16px; font-size: 11px; color: var(--knowledge-muted); a { color: #b82a40; } }\n  .knowledge-reading-layout { display: grid; grid-template-columns: minmax(0, 1fr) 205px; gap: 28px; align-items: start; }\n  .knowledge-toc { grid-column: 2; grid-row: 1; position: sticky; top: 100px; padding: 14px; border: 1px solid var(--knowledge-border); border-radius: 14px; background: #fafbfc; max-height: calc(100dvh - 125px); overflow-y: auto;\n    summary { display: flex; align-items: center; justify-content: space-between; gap: 12px; color: #354158; font-size: 12px; cursor: pointer; min-height: 32px; list-style: none; &::-webkit-details-marker { display: none; } span { color: #929bad; font-size: 10px; } } nav { display: flex; flex-direction: column; padding-top: 9px; gap: 2px; } nav a { color: var(--knowledge-muted); font-size: 11px; line-height: 1.5; padding: 5px 0; &:hover { color: #b82a40; } }\n  }\n  .knowledge-prose { min-width: 0; grid-column: 1; grid-row: 1; font-size: 15px; line-height: 1.8; color: #364154; overflow-wrap: anywhere;\n    > :first-child { margin-top: 0; } p { line-height: inherit; margin: 0 0 18px; } h2 { font-size: 23px; line-height: 1.4; letter-spacing: -.025em; color: #243449; margin: 38px 0 16px; scroll-margin-top: 110px; } h3 { font-size: 19px; line-height: 1.45; color: #243449; margin: 25px 0 13px; } strong { color: #27364a; } ul, ol { padding-left: 22px; margin: 14px 0 23px; } li { margin: 0 0 10px; padding-left: 4px; } a, .knowledge-file-link { color: #bd2940; text-decoration: underline; text-underline-offset: 3px; } figure { margin: 24px 0; max-width: 100%; } figcaption { margin-top: 9px; text-align: left; color: #818a9a; font-size: 12px; line-height: 1.6; } blockquote { margin: 20px 0; padding: 15px 18px; background: #f7f8fb; border-left: 3px solid #dce3ec; border-radius: 0 10px 10px 0; } pre { max-width: 100%; overflow-x: auto; padding: 15px; background: #f5f7fa; border-radius: 12px; font-size: 13px; } iframe { width: 100%; border: 0; aspect-ratio: 16 / 9; border-radius: 12px; } table { width: 100%; border-collapse: collapse; font-size: 13px; } td, th { border: 1px solid var(--knowledge-border); padding: 10px; text-align: left; min-width: 95px; } th { background: #f7f8fa; } .knowledge-table { overflow-x: auto; max-width: 100%; margin: 24px 0; }\n  }\n  .knowledge-image-button { display: block; width: 100%; padding: 0; border: 1px solid var(--knowledge-border); background: #f7f8fb; border-radius: 13px; overflow: hidden; color: #7b8799; cursor: zoom-in;\n    img { display: block; max-width: 100%; height: auto; width: auto; max-height: none; margin: auto; } > span { display: block; text-align: center; font-size: 10px; padding: 7px 10px; }\n  }\n  .knowledge-image-state { display: block; padding: 28px 16px; font-size: 12px; background: #f7f8fb; border-radius: 13px; text-align: center; button { min-height: 44px; background: none; border: none; color: #b72a40; } }\n  .knowledge-file-link { background: none; border: none; padding: 0; text-align: left; min-height: 44px; }\n  .knowledge-article-footer { display: flex; justify-content: space-between; align-items: center; gap: 15px; border-top: 1px solid var(--knowledge-border); padding-top: 24px; margin-top: 30px; strong { font-size: 14px; } p { font-size: 12px; margin: 5px 0 0; color: var(--knowledge-muted); } a { color: #b82a40; font-size: 13px; min-height: 44px; display: flex; align-items: center; } }\n  .knowledge-lightbox img { display: block; max-width: 100%; height: auto; margin: auto; }\n  @media (max-width: 1150px) { .knowledge-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n  @media (max-width: 999px) {\n    .knowledge-reading-layout { display: flex; flex-direction: column; gap: 24px; } .knowledge-toc { position: static; max-height: none; width: 100%; } .knowledge-toc summary { min-height: 40px; } .knowledge-toc nav a { font-size: 13px; padding-block: 8px; } .knowledge-prose { width: 100%; }\n  }\n  @media (max-width: 650px) {\n    .knowledge-heading { gap: 9px; margin-bottom: 20px; align-items: flex-end; } .knowledge-heading h1 { font-size: 28px; } .knowledge-assistant { font-size: 11px; padding: 8px 10px; gap: 5px; max-width: 146px; } .knowledge-eyebrow { font-size: 9px; letter-spacing: .1em; }\n    .knowledge-hero { padding: 19px; border-radius: 20px; margin-bottom: 17px; > div { padding-right: 43px; } h2 { font-size: 21px; max-width: 235px; } p { font-size: 13px; margin-bottom: 19px; } } .knowledge-hero-icon { width: 40px; height: 40px; border-radius: 13px; right: -2px; top: 0; svg { width: 24px; height: 24px; } }\n    .knowledge-search { gap: 6px; padding: 5px 5px 5px 11px; border-radius: 13px; input { font-size: 16px; } button { padding-inline: 12px; font-size: 12px; } > svg { width: 18px; flex-basis: 18px; } }\n    .knowledge-sections { margin-bottom: 18px; }\n    .knowledge-results-heading { align-items: flex-start; gap: 9px; h2 { font-size: 18px; } label { font-size: 0; } select { font-size: 12px; max-width: 139px; } }\n    .knowledge-cards { grid-template-columns: minmax(0, 1fr); gap: 11px; } .knowledge-card { min-height: 0; padding: 18px; h3 { font-size: 19px; margin-top: 15px; } > p { font-size: 13px; margin-bottom: 17px; } }\n    .knowledge-help { flex-wrap: wrap; padding: 18px; gap: 11px; > div { flex: 1; min-width: 0; } a { margin-left: 35px; } }\n    .knowledge-article { padding: 20px 17px; border-radius: 20px; } .knowledge-article-heading { padding-bottom: 22px; margin-bottom: 22px; h1 { font-size: 28px; } } .knowledge-summary { font-size: 14px; } .knowledge-article-meta { gap: 8px 12px; font-size: 10px; }\n    .knowledge-prose { font-size: 16px; line-height: 1.75; h2 { font-size: 23px; margin-top: 32px; } ul, ol { padding-left: 20px; } figcaption { font-size: 11px; } }\n    .knowledge-article-footer { flex-direction: column; align-items: flex-start; gap: 7px; }\n    .knowledge-lightbox { padding: 16px 10px; width: calc(100vw - 12px); max-width: none; }\n  }\n  @media (prefers-reduced-motion: reduce) { .knowledge-card { transition: none; } .knowledge-loading span { animation: none; } }\n}\n@keyframes knowledge-spin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
